var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bb-progress"},[_c('div',{staticClass:"bb-progress__bar",style:({ width: _vm.now + '%' }),attrs:{"role":"progressbar","aria-valuenow":_vm.now,"aria-valuemin":_vm.min,"aria-valuemax":_vm.max}})])}
var staticRenderFns = []

export { render, staticRenderFns }